import { render, staticRenderFns } from "./Flandre.vue?vue&type=template&id=74840d10&scoped=true&"
import script from "./Flandre.vue?vue&type=script&lang=js&"
export * from "./Flandre.vue?vue&type=script&lang=js&"
import style0 from "./Flandre.vue?vue&type=style&index=0&id=74840d10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74840d10",
  null
  
)

export default component.exports